export const Shadows = {
	small: '0 6px 12px 0 rgba(0, 0, 0, 0.3)',
	button: '0 0 0 0 rgba(0, 0, 0, 0)',
	overlay: '0 0 10px 0 rgba(0, 0, 0, 0.2)',
	header: '0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12)',
	footer: '0px -2px 4px -1px rgba(0, 0, 0, 0.2), 0px -4px 5px 0px rgba(0, 0, 0, 0.14), 0px -1px 10px 0px rgba(0, 0, 0, 0.12)',
	strong: 'rgb(0, 0, 0, .5) 4px 4px 6px 1px',
};